<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable>
                <Option v-for="item in warehouseData" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <div class="filterItem">
              <Form-item :label="$t('key1000598')">
                <local-tabButton :tabButtonList="commodityStatusList" @selectStatus="commodityStatus"></local-tabButton>
              </Form-item>
            </div>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="`${configCharacters(false)}` + 'SKU：'" prop="ymsSkus">
              <Input :placeholder="$t('key1003956')+`${configCharacters(false)}`+$t('key1004666')" v-model.trim="pageParams.ymsSkus"
                type="textarea"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="`${configCharacters(false)}` + 'SPU：'" prop="ymsSpus">
              <Input :placeholder="$t('key1003956')+`${configCharacters(false)}`+$t('key1004667')" v-model.trim="pageParams.ymsSpus"
                type="textarea"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003353')" prop="supplierMerchantIdList">
              <Input type="textarea" :placeholder="$t('key1004668')"
                v-model.trim="pageParams.supplierMerchantIdList"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="pageParams.selectType === 2">
            <Form-item :label="$t('key1004669')" prop="warehouseLocationCode">
              <Input :placeholder="$t('key1004670')" v-model.trim="pageParams.warehouseLocationCode"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004095')" prop="merchantType">
              <div class="flex align-items-center">
                <Select v-model="pageParams.merchantType" style="width: 100px;" class="mr10" :placeholder="$t('key1000101')" @on-change="changeMerchantType">
                  <Option v-for="item in merchantTypeList" :value="item.value">{{ item.name }}</Option>
                </Select>
                <Input :placeholder="$t('key1004671')" :disabled="pageParams.merchantType === 3"
                  clearable v-model.trim="pageParams.vestMerchantId" style="width: 140px;"></Input>
              </div>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <div class="flex align-items-center">
              <Select v-model="selectValue" @on-change="changeInputValue" style="width: 110px;">
                <Option v-for="item in dropDownInputList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
              <div class="flex align-items-center ml10">
                <InputNumber
                  :min="0"
                  v-model="pageParams[parameterKeys[0]]"
                  :formatter="value => `${parseInt(value)}`"
                  class="width_110">
                </InputNumber>
                <span class="ml12 mr12">-</span>
                <InputNumber
                  :max="9999999"
                  v-model="pageParams[parameterKeys[1]]"
                  :formatter="value => `${parseInt(value)}`"
                  class="width_110">
                </InputNumber>
              </div>
              <Tooltip transfer placement="top" max-width="600" :content="$t('key1004672')" v-show="selectValue === 3">
                <Icon class="cursor ml5 themeColor" size="18" type="md-help-circle"></Icon>
              </Tooltip>
            </div>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004673')" prop="invalidQuantity">
              <div class="flex align-items-center">
                <InputNumber
                  :min="0"
                  v-model="pageParams.minFrozenNumber"
                  :formatter="value => `${parseInt(value)}`"
                  class="width_110">
                </InputNumber>
                <span class="ml12 mr12">-</span>
                <InputNumber
                  :max="9999999"
                  v-model="pageParams.maxFrozenNumber"
                  :formatter="value => `${parseInt(value)}`"
                  class="width_110">
                </InputNumber>
              </div>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box justify-content-between">
      <div class="flex align-items-center">
        <div class="mr15 sort_options_box">
          <span>{{ $t('key1004046') }}</span>
          <Button-group>
            <Button :type="item.checked ? 'primary' : 'default'"
              v-for="item in sortData"
              @click="clickSortButton(item)"
              :key="item.value">{{ item.label }}
              <Icon type="md-arrow-up" v-if="item.checked && !item.toogle"></Icon>
              <Icon type="md-arrow-down" v-if="item.checked && item.toogle"></Icon>
            </Button>
          </Button-group>
        </div>
        <Button type="primary" class="mr15" @click="$refs.commonImport.importModal = true">{{ $t('key1000765') }}</Button>
        <Dropdown transfer @on-click="(value) => changeExportBtn(value,'inventoryBalance_')" class="mr15"
          v-if="getPermission('ymsInventory_batchExport') && pageParams.selectType === 2">
          <Button type="primary">
            <span>{{ $t('key1004676') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown transfer @on-click="(value) => changeExportBtn(value,'inventoryDetails_')"
          class="mr15" v-if="pageParams.selectType === 2">
          <Button type="primary">
            <span>{{ $t('key1004677') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <local-tabButton :tabButtonList="queryMethodList" @selectStatus="queryMethodBtn"></local-tabButton>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="530"
        :loading="tableLoading"
        :columns="tableColumns"
        @on-selection-change="tableChange"
        @on-sort-change="sortChange"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        :current="pageParams.pageNum"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--打印预览YMS面单弹窗-->
    <printPreviewWaybillModal ref="printPreviewWaybill" :printUrl="apiUrl"></printPreviewWaybillModal>
    <!--导入库存的弹窗-->
    <commonImportModal
      ref="commonImport"
      :importTitle="$t('key1000765')"
      importType="YmsStock"
      fileName="excelFile"
      :warehouseList="warehouseList"
      :uploadAction="uploadZoneExcel"
      @uploadSuccess="pageParamsStatus = true"
      importTemplateKey="ymsInventory">
      {{ $t('key1002622') }}<br/>
      {{ $t('key1004678') }}<br/>
      {{ $t('key1003922') }} .xls .xlsx .csv;<br/>
      {{ $t('key1003923') }}<br/>
      <!--4.导入操作后，请稍后在“导入/导出任务-导入查看”中查看导入结果。-->
    </commonImportModal>
    <!--导出库存余量数据字段弹窗-->
    <exportFieldsModal
      ref="inventoryBalance_exportFields"
      :exportFieldsTitle="$t('key1004674')"
      paramKeyColums="ymsProductInventoryHandlerColumns"
      :customFieldExportList="inventoryBalanceCustomFieldExportList"
      @exportFieldsDataBtn="(obj) => exportFieldsDataBtn(obj, 'inventoryBalance')">
    </exportFieldsModal>
    <!--导出库存明细数据字段弹窗-->
    <exportFieldsModal
      ref="inventoryDetails_exportFields"
      :exportFieldsTitle="$t('key1004675')"
      :timeFiltering="true"
      paramKeyColums="ymsProductInventoryDetailExportHandlerColumns"
      :customFieldExportList="inventoryDetailsCustomFieldExportList"
      @exportFieldsDataBtn="(obj) => exportFieldsDataBtn(obj, 'inventoryDetails')">
    </exportFieldsModal>
    <!--库存详情弹窗-->
    <inventoryBalanceDetailsModal ref="inventoryBalanceDetails" @updateData="pageParamsStatus = true"></inventoryBalanceDetailsModal>
    <!--库存事务明细弹窗-->
    <inventoryTransactionDetailsModal ref="inventoryTransaction" systemType="yms"></inventoryTransactionDetailsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import commonImportModal from "@/components/common/commonImportModal";
import {commonLocalStorage, getDataSetBatchList, getEnableWarehouseData, getEnumList, getEnumName, getWarehouseId, getWarehouseManageInfo, getWarehouseName, isValueEmpty, pageJump, setConfigCharacters} from "@/utils/common";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import inventoryBalanceDetailsModal from "@/views/yms/components/wms/wms-inStock/inventoryBalanceDetailsModal";
import inventoryTransactionDetailsModal from "@/components/common/inventoryTransactionDetailsModal.vue";
import printPreviewWaybillModal from "@/components/common/printPreviewWaybillModal.vue";

export default {
  mixins: [Mixin],
  components: {
    printPreviewWaybillModal,
    commonImportModal,
    exportFieldsModal,
    inventoryBalanceDetailsModal,
    inventoryTransactionDetailsModal
  },
  data() {
    return {
      importTypeList: [
        {value: 'productImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004655')}
      ],
      apiUrl: api.post_productGoods_appendYmsExpressBill,
      pageParamsStatus: false,
      cacheClickVal: 'SKU', // 排序缓存值
      productGoodsId: '',
      wareHouseTypeList: [], // 仓库下拉列表
      // 排序的数据
      sortData: [
        {
          label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004656'),
          value: 'SKU',
          checked: true,
          toogle: true
        }
      ],
      wareId: getWarehouseId(),
      pageParams: {
        status: null, // 商品状态(0:停售 1:在售 2:试卖 3:清仓 默认在售) ,
        ymsSpus: '', // 输入云卖spu
        ymsSkus: '', // 输入云卖spu
        supplierMerchantIdList: '', // 供应商商户号
        ymsWarehouseId: 'null',
        upDown: 'down', // 降序
        orderBy: 'SKU', // 排序的标记
        merchantType: null,
        warehouseLocationCode: '',
        vestMerchantId: '',
        selectType: 1, // 1.按照产品查询  2.按照产品/库位查询
        minAvailableNumber: null, // 可用库存
        maxAvailableNumber: null,
        minAllottedNumber: null, // 分配库存
        maxAllottedNumber: null,
        minInventoryNumber: null, // 总库存
        maxInventoryNumber: null,
        minFrozenNumber: null, // 作废数量
        maxFrozenNumber: null,
        pageNum: 1, // 默认第一页
        pageSize: 15, // 规定每页显示 15 条数据
      },
      total: 0, // 共有多少条
      tableColumns: [],
      tableData: [],
      ymsProductCategoryList: [],
      warehouseList: [],
      uploadZoneExcel: api.post_ymsInventory_excelImport,
      warehouseData: [],
      selectTableData: [],
      exportType: '1',
      inventoryBalanceCustomFieldList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [],
          checkBoxList: [
            {paramKey: 'ymsSku', paramValue: `${setConfigCharacters(false)}SKU`},
            {paramKey: 'cnName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000380')},
            {paramKey: 'ymsWarehouse', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328')},
            {paramKey: 'ymsWarehouseBlock', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002329')},
            {paramKey: 'ymsWarehouseLocation', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002620')},
            {paramKey: 'allottedNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000242')},
            {paramKey: 'availableNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243')},
            {paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {paramKey: 'supplierMerchantName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101')},
            {paramKey: 'specifications', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004657'), disabledDrag: true},
            {paramKey: 'merchantType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004658')},
            {paramKey: 'vestMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004659')},
          ]
        }
      ],
      inventoryDetailsCustomFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [],
          checkBoxList: [
            {paramKey: 'ymsSku', paramValue: `${setConfigCharacters(false)}SKU`},
            {paramKey: 'cnName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000380')},
            {paramKey: 'ymsWarehouse', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328')},
            {paramKey: 'ymsWarehouseBlock', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002329')},
            {paramKey: 'ymsWarehouseLocation', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002620')},
            {paramKey: 'allottedNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000242')},
            {paramKey: 'availableNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243')},
            {paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {paramKey: 'supplierMerchantName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101')},
            {paramKey: 'merchantType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004658')},
            {paramKey: 'vestMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004659')},
            {paramKey: 'typeStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000742')},
            {paramKey: 'availableStockChangeStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000740')},
            {paramKey: 'curAvailableNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000743')},
            {paramKey: 'allocatedStockChangeStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000744')},
            {paramKey: 'curAllottedNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000745')},
            {paramKey: 'relatedBusinessNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000748')},
            {paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000291')},
            {paramKey: 'operator', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292')},
            {paramKey: 'specifications', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004657'), disabledDrag: true},
          ]
        }
      ],
      queryMethodList: [
        {selected: true, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004660')},
        {selected: false, value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004661')},
      ],
      enumData: [],
      commodityIndex: 0,
      selectValue: 1,
      parameterKeys: [],
      dropDownInputList: [
        {value: 1, parameterKeyList: ['minAllottedNumber', 'maxAllottedNumber'], title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001991')},
        {value: 2, parameterKeyList: ['minAvailableNumber', 'maxAvailableNumber'], title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001104')},
        {value: 3, parameterKeyList: ['minInventoryNumber', 'maxInventoryNumber'], title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004662')}
      ]
    };
  },
  computed: {
    // 平台自营商品模式配置
    platformSelfOperatedProduct() {
      let saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.platformSelfOperatedProductModelSaas) === 1;
    },
    inventoryBalanceCustomFieldExportList() {
      if (this.pageParams.selectType === 1) {
        let hideKeyList = ['ymsWarehouseBlock', 'ymsWarehouseLocation'];
        return this.inventoryBalanceCustomFieldList.map((item) => {
          let filteredCheckBoxList = item.checkBoxList.filter((ele) => {
            return !hideKeyList.includes(ele.paramKey);
          });
          return {...item, checkBoxList: filteredCheckBoxList};
        });
      } else {
        return this.inventoryBalanceCustomFieldList;
      }
    },
    // 货主
    merchantTypeList() {
      const ENUM_KEY = 'MerchantTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      if (!this.platformSelfOperatedProduct) {
        list = list.filter((item) => item.value !== 3);
      }
      return list;
    },
    // 商品状态
    commodityStatusList() {
      const ENUM_KEY = 'QueryYmsInventoryBoStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: null,
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list.forEach((item, index) => {
        item.selected = index === this.commodityIndex;
      });
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      v.changeInputValue(1);
      v.handleColumns();
      v.warehouseData = [];
      (async () => {
        let enumKeyList = [
          'MerchantTypeCoreEnum',
          'QueryYmsInventoryBoStatusCoreEnum'
        ];
        v.enumData = await getDataSetBatchList(enumKeyList);
        v.warehouseList = await getEnableWarehouseData(1);
        v.warehouseData.push({
            ymsWarehouseId: 'null',
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
          },
          ...v.warehouseList
        );
        await v.getList();
      })();
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      data.map((item) => {
        if (item.ymsInventoryId) {
          this.selectTableData.push(item.ymsInventoryId);
        }
      });
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value, type) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs[type + 'exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj, type) {
      let v = this;
      let url = '';
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsInventoryIds = v.selectTableData;
      } else {
        query.ymsInventoryIds = [];
      }
      switch (type) {
        case 'inventoryBalance':
          url = api.post_ymsInventory_batchExport;
          break;
        case 'inventoryDetails':
          url = api.post_ymsInventory_batchExportDetail;
          query.selectStartTime = obj.selectStartTime;
          query.selectEndTime = obj.selectEndTime;
          break;
      }
      v.$refs[type + '_exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs[type + '_exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 保存可用数量、作废数量
    saveAvailableQuantity(talgValue, type, params) {
      let v = this;
      let reg = v.$regular.minPositiveInteger;
      let text = type === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004663');
      if (reg.test(talgValue)) {
        let row = params.row;
        let query = {
          ymsWarehouseLocationId: row.ymsWarehouseLocationId,
          ymsProductGoodsId: row.ymsProductGoodsId,
          changedNumber: Number(talgValue),
          checkType: type,
          ymsInventoryId: row.ymsInventoryId,
          vestMerchantId: row.vestMerchantId,
          merchantType: row.merchantType,
        };
        v.axios.put(api.put_ymsInventory, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
          if (res.data.code === 0) {
            if (type === 1) {
              v.$set(row, '$isEdit', !row.$isEdit);
              v.$set(row, 'availableNumber', talgValue);
            } else {
              v.$set(row, '$invalidQuantityEdit', !row.$invalidQuantityEdit);
              v.$set(row, 'frozenNumber', talgValue);
            }
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          }
        });
      } else {
        v.$Message.error(text + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004664'));
      }
    },
    editInput(obj, index, isEdit, type) {
      let v = this;
      setTimeout(() => {
        v.$nextTick(() => {
          document.getElementsByClassName('availableInput_' + index)[0].childNodes[6].focus();
        });
      }, 300);
      if (type === 1) {
        v.$set(obj, '$isEdit', !isEdit);
      } else {
        v.$set(obj, '$invalidQuantityEdit', !isEdit);
      }
    },
    // 选取商品状态
    commodityStatus(index, value) {
      this.pageParams.status = value;
      this.commodityIndex = index;
    },
    // 整理参数
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let nullList = ['ymsWarehouseId'];
      for (let key of nullList) {
        params[key] = v.pageParams[key] === 'null' ? null : v.pageParams[key];
      }
      let filterKeyList = ['ymsSpus', 'ymsSkus', 'supplierMerchantIdList'];
      for (let key in params) {
        if (filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 查询功能
    getList() {
      let v = this;

      function isValidRange(min, max, text) {
        if (!isValueEmpty(min) && !isValueEmpty(max)) {
          if (min <= max) {
            return true;
          } else {
            v.$Message.warning(`${text}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004653')}${text}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004654')}`);
            return false;
          }
        }
        return true;
      }

      let text = v.dropDownInputList.find(item => item.value === v.selectValue).title;
      if (!isValidRange(v.pageParams[v.parameterKeys[0]], v.pageParams[v.parameterKeys[1]], text)) {
        return false;
      }
      if (!isValidRange(v.pageParams.minFrozenNumber, v.pageParams.maxFrozenNumber, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004663'))) {
        return false;
      }

      handleList();

      function handleList() {
        v.optionBtnWidth = [];
        v.total = 0;
        v.tableData = [];
        v.selectTableData = [];
        if (v.getPermission('ymsInventory_query')) {
          v.tableLoading = true;
          v.axios.post(api.post_ymsInventory_query, v.handleParameter()).then(res => {
            if (res.data.code === 0) {
              let data = res.data.datas;
              if (data) {
                v.total = data.total;
                let tableData = data.list || [];
                let ymsWarehouseLocationIds = [];
                let ymsProductGoodsIds = [];
                if (tableData.length > 0) {
                  tableData.map((item) => {
                    ymsWarehouseLocationIds.push(item.ymsWarehouseLocationId);
                    ymsProductGoodsIds.push(item.ymsProductGoodsId);
                  });
                  if (ymsWarehouseLocationIds.length > 0) {
                    (async () => {
                      let data = await getWarehouseManageInfo(ymsWarehouseLocationIds, tableData);
                      v.tableData = await v.getProductInfoByIds(ymsProductGoodsIds, data);
                      v.updateTableDom('selection');
                    })();
                  }
                } else {
                  v.tableData = tableData;
                  v.updateTableDom('selection');
                }
                if (v.tableData.length > 0) {
                  v.tableData.map((item) => {
                    item['$isEdit'] = false;
                    item['$invalidQuantityEdit'] = false;
                  });
                }
              }
            } else {
              v.tableLoading = false;
            }
          });
        } else {
          v.gotoError();
        }
      }
    },
    // 页面查询
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 点击排序的按钮
    clickSortButton(data) {
      if (data.value === this.cacheClickVal) {
        data.toogle = !data.toogle;
      }
      this.cacheClickVal = data.value;
      if (data.toogle) {
        this.pageParams.upDown = 'down';
      } else {
        this.pageParams.upDown = 'up';
      }
      this.sortData.forEach(function (n) {
        n.checked = data.value === n.value;
      });
      this.pageParams.orderBy = data.value;
      this.getList();
    },
    // 重置按钮
    reset() {
      this.$refs['pageParams'].resetFields();
      this.pageParams.merchantType = null;
      this.pageParams.vestMerchantId = '';
      this.commodityStatus(0, null);
      this.changeInputValue(1);
      this.pageParams.minFrozenNumber = null;
      this.pageParams.maxFrozenNumber = null;
      this.search();
    },
    // 切换维度
    queryMethodBtn(index, value) {
      let v = this;
      v.pageParams.warehouseLocationCode = '';
      v.pageParams.selectType = value;
      v.handleColumns();
      v.queryMethodList.forEach((n, i) => {
        n.selected = i === index;
      });
      v.pageParamsStatus = true;
      v.$forceUpdate();
    },
    // 处理列表Columns字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let columns = [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          key: 'index',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 320,
          key: 'productInfo',
          align: 'center',
          render: (h, params) => {
            return v.tableProductInformation(h, params);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'),
          key: 'supplierMerchantName',
          minWidth: 170,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004658'),
          key: 'merchantType',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let merchantType = params.row.merchantType;
            let text = getEnumName(v.enumData, 'MerchantTypeCoreEnum', merchantType, 'number');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004659'),
          key: 'vestMerchantId',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let warehouseName = params.row.warehouseName;
            let ymsWarehouseId = params.row.ymsWarehouseId;
            if (v.pageParams.selectType === 2) {
              return h('span', warehouseName);
            } else {
              return h('span', getWarehouseName(v.warehouseList, ymsWarehouseId));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002315'),
          key: 'warehouseBlockName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002620'),
          key: 'warehouseLocalName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000242'),
          key: 'allottedNumber',
          minWidth: 130,
          align: 'center',
          sortable: 'custom',
          render(h, params) {
            let allottedNumber = params.row.allottedNumber;
            if (v.pageParams.selectType === 1) {
              return h('Alink', {
                props: {
                  className: 'justify-content-center',
                  AlinkShow: true,
                  linkName: allottedNumber
                },
                on: {
                  AlinkBtn: () => {
                    v.$refs['inventoryBalanceDetails'].initInventoryBalanceDetailsData(params.row);
                  }
                }
              });
            } else {
              return h('span', allottedNumber);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243'),
          key: 'availableNumber',
          minWidth: 150,
          sortable: 'custom',
          align: 'center',
          render(h, params) {
            let availableNumber = params.row.availableNumber;
            if (v.pageParams.selectType === 1) {
              return h('Alink', {
                props: {
                  className: 'justify-content-center',
                  AlinkShow: true,
                  linkName: availableNumber
                },
                on: {
                  AlinkBtn: () => {
                    v.$refs['inventoryBalanceDetails'].initInventoryBalanceDetailsData(params.row);
                  }
                }
              });
            } else {
              let currentIndex = params.index;
              let isEdit = params.row.$isEdit && v.getPermission('ymsInventory_update');
              let value = params.row.availableNumber;
              let opts = '';
              if (isEdit) {
                let talgValue = params.row.availableNumber;
                opts = h('div', {
                    class: 'flex justify-content-center align-items-center'
                  },
                  [
                    h('Input', {
                      style: {
                        width: '80px',
                        height: '32px'
                      },
                      props: {
                        value: value,
                        autofocus: true
                      },
                      attrs: {
                        class: 'availableInput_' + currentIndex,
                      },
                      on: {
                        input: val => {
                          talgValue = val;
                        },
                        'on-enter': () => {
                          v.saveAvailableQuantity(talgValue, 1, params);
                        },
                      }
                    }),
                    h('Icon', {
                      props: {
                        type: 'md-checkmark',
                        size: 20
                      },
                      style: {
                        marginLeft: '5px'
                      },
                      class: 'cursor',
                      on: {
                        click: () => {
                          v.saveAvailableQuantity(talgValue, 1, params);
                        }
                      }
                    }),
                    h('Icon', {
                      props: {
                        type: 'md-close-circle',
                        color: '#f00',
                        size: 20
                      },
                      style: {
                        marginLeft: '5px'
                      },
                      class: 'cursor',
                      on: {
                        click: () => {
                          v.$set(params.row, '$isEdit', !isEdit);
                        }
                      }
                    })
                  ]);
              } else {
                opts = h('div', null, [
                  h('a', {
                    style: {
                      color: '#2586ED',
                      fontSize: '13px'
                    },
                    on: {
                      click: () => {
                        v.editInput(params.row, currentIndex, isEdit, 1);
                      }
                    }
                  }, value),
                  h('Icon', {
                    props: {
                      type: 'md-create',
                    },
                    style: {
                      'margin-left': '5px',
                      'cursor': 'pointer'
                    },
                    on: {
                      'click'() {
                        v.editInput(params.row, currentIndex, isEdit, 1);
                      }
                    }
                  })
                ]);
              }
              return opts;
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004663'),
          key: 'frozenNumber',
          minWidth: 150,
          align: 'center',
          sortable: 'custom',
          render(h, params) {
            let frozenNumber = params.row.frozenNumber;
            if (v.pageParams.selectType === 1) {
              return h('Alink', {
                props: {
                  className: 'justify-content-center',
                  AlinkShow: true,
                  linkName: frozenNumber
                },
                on: {
                  AlinkBtn: () => {
                    v.$refs['inventoryBalanceDetails'].initInventoryBalanceDetailsData(params.row);
                  }
                }
              });
            } else {
              let currentIndex = params.index;
              let invalidQuantityEdit = params.row.$invalidQuantityEdit && v.getPermission('ymsInventory_update');
              let value = params.row.frozenNumber;
              let opts = '';
              if (invalidQuantityEdit) {
                let talgValue = params.row.frozenNumber;
                opts = h('div', {
                    class: 'flex justify-content-center align-items-center'
                  },
                  [
                    h('Input', {
                      style: {
                        width: '80px',
                        height: '32px'
                      },
                      props: {
                        value: value,
                        autofocus: true
                      },
                      attrs: {
                        class: 'availableInput_' + currentIndex,
                      },
                      on: {
                        input: val => {
                          talgValue = val;
                        },
                        'on-enter': () => {
                          v.saveAvailableQuantity(talgValue, 2, params);
                        },
                      }
                    }),
                    h('Icon', {
                      props: {
                        type: 'md-checkmark',
                        size: 20
                      },
                      style: {
                        marginLeft: '5px'
                      },
                      class: 'cursor',
                      on: {
                        click: () => {
                          v.saveAvailableQuantity(talgValue, 2, params);
                        }
                      }
                    }),
                    h('Icon', {
                      props: {
                        type: 'md-close-circle',
                        color: '#f00',
                        size: 20
                      },
                      style: {
                        marginLeft: '5px'
                      },
                      class: 'cursor',
                      on: {
                        click: () => {
                          v.$set(params.row, '$invalidQuantityEdit', !invalidQuantityEdit);
                        }
                      }
                    })
                  ]);
              } else {
                opts = h('div', null, [
                  h('a', {
                    style: {
                      color: '#2586ED',
                      fontSize: '13px'
                    },
                    on: {
                      click: () => {
                        v.editInput(params.row, currentIndex, invalidQuantityEdit, 2);
                      }
                    }
                  }, value),
                  h('Icon', {
                    props: {
                      type: 'md-create',
                    },
                    style: {
                      'margin-left': '5px',
                      'cursor': 'pointer'
                    },
                    on: {
                      'click'() {
                        v.editInput(params.row, currentIndex, invalidQuantityEdit, 2);
                      }
                    }
                  })
                ]);
              }
              return opts;
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          fixed: 'right',
          width: 220,
          render: function (h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004665'),
                    show: v.getPermission('ymsInventoryChangeLog_query') && v.pageParams.selectType === 2,
                    clickFn: () => {
                      v.$refs['inventoryTransaction'].initFun(params.row);
                    }
                  },
                  {
                    text: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000320')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000616')}`,
                    show: v.getPermission('productGoods_appendYmsExpressBill'),
                    clickFn: () => {
                      let obj = {
                        ...params.row,
                        ymsSku: params.row._productInfo.ymsSku
                      };
                      v.$refs['printPreviewWaybill'].initPrintPreviewWaybillData(obj);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      let hideKeyList = [];
      let selectType = v.pageParams.selectType;
      if (selectType === 1) {
        hideKeyList = ['warehouseBlockName', 'warehouseLocalName'];
      }
      v.tableColumns = columns.filter((item) => {
        return !hideKeyList.includes(item.key);
      });
      v.$forceUpdate();
    },
    // 数量排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    },
    // 选择库存类型
    changeInputValue(value) {
      let obj = this.dropDownInputList.find(item => item.value === value);
      this.parameterKeys = obj.parameterKeyList;
      this.selectValue = value;
      this.dropDownInputList.map((item) => {
        item.parameterKeyList.map((ele) => {
          this.pageParams[ele] = null;
        })
      });
    },
    // 切换货主
    changeMerchantType() {
      this.pageParams.vestMerchantId = '';
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
};
</script>

<style lang="less" scoped>

</style>
